module.exports = __webpack_public_path__ + "img/10hearts.00a225f8.jpg";